import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { CouponsListFiltersArray } from './Filters'

const CouponsListFilters: React.FC<Omit<FilterProps, 'children'>> = (props) => {
  return (
    <Filter {...props}>
      {CouponsListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default CouponsListFilters
